import { html } from "lit";
import { getDummyText, renderStandardPictureElement } from "../../../utils";
import { Template as headline } from "../../../shared/headline";

const dummyDownloadDesc = getDummyText(650);

export const dummyDownload = {
    downloadTitle: "Wir sind für sie da!",
    downloadDescription: dummyDownloadDesc,
    linkUrl: "#",
    linkIcon: "chevron-right",
    tag: "whitepaper",
    shortDescription: "01.01.1970 - PDF 1.2MB",
};

export const dummyDownloads = Array(8).fill({ ...dummyDownload });

const TeaserSelectableDownloadTemplate = () =>
    html`<ux-iws-teaser-selectable-download>
        ${renderStandardPictureElement({
            width: 420,
            height: 620,
        })}
        <ux-checkbox
            slot="checkbox"
            name="whitepaper"
            value="whitepaper-1"
            no-label
        >
        </ux-checkbox>
        <span slot="file-info" class="ux-text-tiny">
            01.01.1970 PDF - 1.2MB
        </span>
        <div slot="text">
            <div class="ux-text-title-teaser ux-u-margin-bottom-5">
                Wir sind für sie da
            </div>
            <ux-text-lines-limit
                read-more-text="Read more"
                text-lines-s="2"
                text-lines-m="3"
                text-lines-l="3"
                text-lines-xl="3"
            >
                <div class="ux-text-normal ux-text-normal--light-gray">
                    ${getDummyText(300)}
                </div>
            </ux-text-lines-limit>
        </div>
    </ux-iws-teaser-selectable-download>`;

export function Step1(storyArgs) {
    return html`
        ${headline()}
        <div class="row">
            <div class="gr-10 push-1 ux-u-shadow">
                <div class="row">
                    <div class="gr-12 no-gutter ux-u-margin-top-35">
                        <div class="row">
                            <div class="gr-12 no-gutter@m">
                                <ux-form async>
                                    ${firstStep(storyArgs)}
                                </ux-form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
}

export const firstStep = (storyArgs) => {
    return html`
        <form
            action="./mock-data/whitepaper/whitepaper-step-2.html"
            method="POST"
        >
            <div class="row">
                <!-- CLASSES OF THE FOLLOWING ELEMENT DIFFER FOR THE LAYOUT WITH SIDEBAR -->
                <div
                    class="${getDownloadsContainerAdditionalClasses(
                        storyArgs.oneColumn,
                        storyArgs.marginalColumn
                    )} gr-12 no-gutter"
                >
                    ${!storyArgs.oneDownload
                        ? html`
                              <ux-form-group
                                  data-validation-group--min="1"
                                  data-validation-group--msg="Select at least one whitepaper"
                                  manage-all-checkboxes="Select all"
                                  manage-all-wrapper-class="ux-u-margin-horizontal-15 ux-u-margin-bottom-25"
                              >
                                  <div class="row">
                                      <div class="gr-12">
                                          <div class="ux-u-border-bottom"></div>
                                      </div>
                                      <!-- CLASSES AND STRUCTURE OF THE FOLLOWING ELEMENT DIFFER FOR THE LAYOUT WITH SIDEBAR -->
                                      ${storyArgs.oneColumn
                                          ? html`
                                                <div class="gr-12 no-gutter">
                                                    ${[...dummyDownloads]
                                                        .splice(0, 3)
                                                        .map(
                                                            () => html`
                                                                <div
                                                                    class="gr-12"
                                                                >
                                                                    ${TeaserSelectableDownloadTemplate()}
                                                                </div>
                                                            `
                                                        )}
                                                </div>
                                            `
                                          : html`
                                                <div
                                                    class="gr-12 no-gutter gr-6@large"
                                                >
                                                    ${[...dummyDownloads]
                                                        .splice(0, 3)
                                                        .map(
                                                            () => html`
                                                                <div
                                                                    class="gr-12"
                                                                >
                                                                    ${TeaserSelectableDownloadTemplate()}
                                                                </div>
                                                            `
                                                        )}
                                                </div>
                                                <div
                                                    class="gr-12 no-gutter gr-6@large"
                                                >
                                                    ${[...dummyDownloads]
                                                        .splice(0, 3)
                                                        .map(
                                                            () => html`
                                                                <div
                                                                    class="gr-12"
                                                                >
                                                                    ${TeaserSelectableDownloadTemplate()}
                                                                </div>
                                                            `
                                                        )}
                                                </div>
                                            `}
                                  </div>
                              </ux-form-group>
                          `
                        : html`
                              ${[...dummyDownloads].splice(0, 3).map(
                                  () => html`
                                      <ux-form-group>
                                          <div class="row">
                                              <div class="gr-12">
                                                  <div
                                                      class="ux-u-border-bottom"
                                                  ></div>
                                              </div>
                                          </div>
                                          <div class="gr-12">
                                              ${TeaserSelectableDownloadTemplate()}
                                          </div>
                                      </ux-form-group>
                                  `
                              )}
                          `}
                </div>
                <div class="gr-12">
                    <div class="ux-u-margin-top-30 ux-u-text-align--center">
                        <button
                            type="submit"
                            class="ux-button ux-button--green ux-u-margin-vertical-10"
                        >
                            Download
                        </button>
                    </div>
                </div>
            </div>
        </form>
    `;
};

export const secondStep = (storyArgs) => {
    return html`
        <form action="./mock-data/whitepaper/whitepaper-success.html">
            <div class="row">
                <!-- CLASSES OF THE FOLLOWING ELEMENT DIFFER FOR THE LAYOUT WITH SIDEBAR -->
                <div
                    class="${getFormContainerAdditionalClasses(
                        storyArgs.oneColumn,
                        storyArgs.marginalColumn
                    )} gr-12 no-gutter@m"
                >
                    <div class="row">
                        ${formElementWrapper(
                            html`
                                <ux-select
                                    name="anrede"
                                    label="Anrede"
                                    required
                                    full-width
                                >
                                    <option value="" selected></option>
                                    <option value="option-1">Herr</option>
                                    <option value="option-2">Frau</option>
                                </ux-select>
                            `,
                            storyArgs.oneColumn
                        )}
                        ${formElementWrapper(
                            html`
                                <ux-input-field label="Vorname" required>
                                </ux-input-field>
                            `,
                            storyArgs.oneColumn
                        )}
                        ${formElementWrapper(
                            html`
                                <ux-input-field label="Nachname" required>
                                </ux-input-field>
                            `,
                            storyArgs.oneColumn
                        )}
                        ${formElementWrapper(
                            html`
                                <ux-data-ingest static-suggestions="#countries">
                                    <ux-autosuggest-input
                                        label="select a country"
                                        required
                                        placeholder="Enter the land"
                                    >
                                    </ux-autosuggest-input>
                                    <script
                                        type="application/json"
                                        data-id="countries"
                                    >
                                        [
                                            {
                                                "value": "DE",
                                                "label": "Germany"
                                            },
                                            { "value": "IT", "label": "Italy" },
                                            { "value": "ES", "label": "Spain" },
                                            {
                                                "value": "NL",
                                                "label": "Netherlands"
                                            },
                                            {
                                                "value": "FR",
                                                "label": "France"
                                            },
                                            {
                                                "value": "UK",
                                                "label": "United Kingdom"
                                            },
                                            {
                                                "value": "US",
                                                "label": "United States"
                                            },
                                            {
                                                "value": "CO",
                                                "label": "Colombia"
                                            },
                                            {
                                                "value": "CH",
                                                "label": "Switzerland"
                                            },
                                            {
                                                "value": "ZB",
                                                "label": "Zimbawe"
                                            }
                                        ]
                                    </script>
                                </ux-data-ingest>
                            `,
                            storyArgs.oneColumn
                        )}
                        ${formElementWrapper(
                            html`
                                <ux-input-field label="Unternehmen" required>
                                </ux-input-field>
                            `,
                            storyArgs.oneColumn
                        )}
                        ${formElementWrapper(
                            html`
                                <ux-input-field
                                    label="Email adresse"
                                    required
                                    type="email"
                                >
                                </ux-input-field>
                            `,
                            storyArgs.oneColumn
                        )}
                        ${formElementWrapper(
                            html`
                                <ux-checkbox required name="privacy">
                                    <span class="ux-text-tiny">
                                        I hereby consent to the TRUMPF Group
                                        processing my previously entered data
                                        for purposes of market research,
                                        advertising and analysis and to its
                                        contacting me by post, email or phone
                                        for the purpose of informing me of its
                                        current offers and services. I can at
                                        any time revoke this consent, even
                                        partially, by contacting
                                        mailings_holding@de.trumpf.com Further
                                        information on data protection at TRUMPF
                                        can be found in our privacy statement. *
                                        Privacy
                                    </span>
                                </ux-checkbox>
                            `,
                            true
                        )}
                        <div class="gr-12 ux-u-margin-bottom-25">
                            <div
                                class="ux-text-normal ux-text-normal--light-gray"
                            >
                                * Pflichtfelder sind mit einem * gekennzeichnet.
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div
                            class="gr-12 ux-u-text-align--center ux-u-margin-top-10"
                        >
                            <div
                                class="ux-button-group ux-button-group--with-spacing"
                            >
                                <button
                                    class="ux-button"
                                    type="button"
                                    formaction="./mock-data/whitepaper/whitepaper-step-1.html"
                                    formnovalidate
                                >
                                    Previous
                                </button>
                                <button
                                    type="submit"
                                    class="ux-button ux-button--green"
                                >
                                    Download
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    `;
};

export const successTemplate = () => {
    return html`
        <div class="row">
            <div
                class="gr-12 no-gutter ux-u-margin-top-30 ux-u-margin-bottom-5 ux-u-margin-l-top-40 
                      ux-u-margin-l-bottom-15 ux-u-margin-xl-top-50 ux-u-margin-xl-bottom-25"
            >
                ${headline()}
                <div class="row">
                    <div class="gr-10 push-1 ux-u-shadow">
                        <div class="row">
                            <div
                                class="gr-12 ux-u-margin-bottom-40 ux-u-margin-top-35"
                            >
                                <ux-form
                                    data-validation-required--msg="This field is required"
                                    async
                                >
                                    <div class="row">
                                        <div
                                            class="gr-12 no-gutter ux-u-margin-bottom-40"
                                        >
                                            <div class="row">
                                                <div
                                                    class="gr-12 u-hide@t u-hide@d u-hide@large ux-u-text-align--center"
                                                >
                                                    <ux-icon
                                                        name="checkmark"
                                                        class="ux-color-success"
                                                        size-s="45"
                                                    ></ux-icon>
                                                </div>
                                                <div
                                                    class="gr-12 ux-u-center-content ux-u-text-align--center"
                                                >
                                                    <ux-icon
                                                        name="checkmark"
                                                        class="ux-color-success u-hide@m ux-u-margin-right-15 ux-u-margin-bottom-10"
                                                        size-s="50"
                                                    ></ux-icon>
                                                    <span
                                                        class="ux-text-headline ux-text-headline--medium"
                                                    >
                                                        Vielen Dank für Ihre
                                                        Interesse
                                                    </span>
                                                </div>
                                                <div
                                                    class="gr-12 ux-u-text-align--center"
                                                >
                                                    <div
                                                        class="ux-text-normal ux-text-normal--light-gray"
                                                    >
                                                        Wir senden Ihnen die
                                                        ausgewählte an die
                                                        angegebene E-Mail
                                                        Addresse. Bitte schauen
                                                        Sie auch in ihrem
                                                        Spam-Ordner.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ux-form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
};

export const formElementWrapper = (element, oneColumn) => {
    return html`
        <!-- CLASSES OF THE FOLLOWING ELEMENT DIFFER FOR THE LAYOUT WITH TWO COUMNS -->
        <div
            class="gr-12@t gr-12@m ${oneColumn
                ? `gr-12`
                : `gr-6`} ux-u-margin-bottom-25"
        >
            ${element}
        </div>
    `;
};

export const getFormContainerAdditionalClasses = (
    hasOneColumn,
    hasMarginalColumn
) => {
    if (hasOneColumn && !hasMarginalColumn)
        return `gr-6@large push-3@large gr-10@d push-1@d`;
    else if (hasOneColumn && hasMarginalColumn)
        return `gr-8@large push-2@large gr-10@d push-1@d`;
    else if (!hasOneColumn && !hasMarginalColumn)
        return `gr-8@large push-2@large gr-12@d push-0@d`;
    else return `gr-12@large push-0@large gr-12@d push-0@d`;
};

export const getDownloadsContainerAdditionalClasses = (
    hasOneColumn,
    hasMarginalColumn
) => {
    if (hasOneColumn && !hasMarginalColumn)
        return `gr-8@large push-2@large gr-10@d push-1@d`;
    else if (hasOneColumn && hasMarginalColumn)
        return `gr-12@large push-0@large gr-10@d push-1@d`;
    else if (!hasOneColumn && !hasMarginalColumn)
        return `gr-12@large push-0@large gr-12@d push-0@d`;
    else return `gr-12@large push-0@large gr-12@d push-0@d`;
};
